import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";

import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const Editratemaster = () => {
  useAuthRedirect();
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fld_rate: "", fld_date: "" });

  const canEdit = hasPermission("Vehicle TDS Percentage", "edit");

  // Fetch data
  useEffect(() => {
    const fetchVehicleType = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_rate_master_api/${id}`
        );
        setFormData({
          fld_rate: response.data.fld_rate,
          fld_date: response.data.fld_date,
        });
      } catch (error) {
        console.error("Error fetching vehicle type:", error);
      }
    };

    fetchVehicleType();
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "fld_date") {
  const today = new Date();
  const selectedDate = new Date(value);

  // Compare only Y-M-D (ignore hours/minutes/seconds)
  const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const selectedDateOnly = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());

  if (selectedDateOnly > todayDateOnly) {
    Swal.fire({
      icon: "error",
      title: "Invalid Date",
      text: "You cannot select a future date!",
    });
    return; // don't update state if invalid
  }
}

    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.put(
        `https://rfs2.infraconsoft.net.in/api/edit_rate_master_api/${id}`,
        formData
      );

      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Rate Updated successfully.",
      });

      setFormData({ fld_rate: "", fld_date: "" });

      setTimeout(() => navigate("/vehicle_ratemaster"), 500);
    } catch (error) {
      console.error("Error updating details:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Please Try Again",
      });
    }
  };

  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Vehicle TDS - Edit</h2>
            <Link to={`/vehicle_ratemaster`}>
              <p className="back-button">
                <i className="fa-solid fa-backward"></i> Back
              </p>
            </Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Rate:</label>
                <input
                  type="text"
                  name="fld_rate"
                  value={formData.fld_rate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Date:</label>
                <input
                  type="date"
                  name="fld_date"
                  value={
                    formData.fld_date
                      ? new Date(formData.fld_date).toISOString().split("T")[0]
                      : ""
                  }
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Editratemaster;
